import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

let previousPathname: string | null = null;

export const usePreviousPath = (): string | null => previousPathname;

export function RouteTracker(): null {
  const location = useLocation();
  const prevRef = useRef<string | null>(null);

  useEffect(() => {
    previousPathname = prevRef.current;
    prevRef.current = location.pathname;
  }, [location.pathname]);

  return null;
}
